import { render, staticRenderFns } from "./ClickableList.vue?vue&type=template&id=79dd6776&"
import script from "./ClickableList.vue?vue&type=script&lang=js&"
export * from "./ClickableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports